import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import MarkdownRenderer from 'react-markdown-renderer'
import withApiData from '../../../HOC/withApiData'
import { CourseImage } from '../../../styled/CourseImage'
import ActivityCourseCourseImage from '../../../styled/ActivityCourseCourseImage'
import { MasteryLevelImage } from '../../../styled/MasteryLevelImage'
import { hideModal } from '../../../../actions/_modal'
import { getJourneysGroupedByMasterCourse } from '../../../../selectors/studentprofile'
import ModalFullScreen from '../../../mini/ModalFullScreen'
import TargetDateDueText from '../../../mini/TargetDates/TargetDateDueText'
import FlexAlignCenter from '../../../styled/FlexAlignCenter'
import LoadingSpinner from '../../../mini/LoadingSpinner'
import CloseModal from '../../../styled/CloseModal'
import { fetchLevelDetails } from './API'
import MentorGuidance, {
  MENTOR_GUIDANCE_TYPE,
  MentorGuidanceContext
} from '../../../Mentor/Shared/MentorGuidance/Index'
import { Container, ModalTop, ModalBody, P1Description } from './_Styled'
import LevelQuests from './LevelQuests'
import { Caption2, H1 } from '../../../styled/typography/typography'
import { LexiconContext } from '../../../../contexts/Lexicon'

export class LevelModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      levelDetails: null,
      fetching: false,
      levelProgress: props.levelProgress
    }

    this.onNewActivityNotificationBound = this.onNewActivityNotification.bind(
      this
    )
    this.closeTheModalBound = this.closeTheModal.bind(this)
  }

  static contextType = LexiconContext

  async componentDidMount() {
    const { level, apiData, masterCourseId, courseId } = this.props

    const lChannel = window.oeQwPusherInstance.subscribe(
      `quest.users.${this.props.userId}`
    )
    lChannel.bind(
      'activity_approval_updated',
      this.onNewActivityNotificationBound
    )

    this.setState(() => ({
      fetching: true
    }))

    const levelDetails = await fetchLevelDetails(
      level.id,
      apiData,
      masterCourseId,
      courseId
    )

    this.setState(() => ({
      fetching: false,
      levelDetails,
      isClosing: false
    }))
  }

  // ensure global modal (here: Level Modal) is hidden whenever leaving
  componentWillUnmount() {
    const lChannel = window.oeQwPusherInstance.channel(
      `quest.users.${this.props.userId}`
    )
    lChannel.unbind(
      'activity_approval_updated',
      this.onNewActivityNotificationBound
    )
  }

  onNewActivityNotification(data) {
    this.setState(prevState => ({
      levelProgress: {
        ...prevState.levelProgress,
        quests_progress: prevState.levelProgress?.quests_progress
          ? prevState.levelProgress.quests_progress.map(quest => {
              return quest.current_user_quest_activity_id === data.activity.id
                ? {
                    ...quest,
                    new_feedback_available: true,
                    awaiting_approval: false,
                    current_activity_feedback_status: data.activity
                      .disapproved_by
                      ? 'disapproved'
                      : 'approved'
                  }
                : {
                    ...quest
                  }
            })
          : null
      }
    }))
  }

  render() {
    const {
      level,
      handleQuestClick,
      courseColor,
      targetDate,
      courseSectionId,
      isActivityCourse,
      isUserEnrolled
    } = this.props
    const { lexicon } = this.context
    const { levelDetails, levelProgress } = this.state

    let requiredQuests = []
    let choiceQuests = []

    level.quests.forEach(q => {
      const questProgress = levelProgress?.quests_progress
        ? levelProgress.quests_progress.find(lsp => lsp.quest_id === q.id)
        : null
      const questTargetDate = targetDate
        ? targetDate.find(qtd => qtd.quest_id === q.id)
        : null
      if (q.required) {
        requiredQuests.push({
          ...q,
          progress: questProgress,
          targetDate: questTargetDate
        })
      } else {
        choiceQuests.push({
          ...q,
          progress: questProgress,
          targetDate: questTargetDate
        })
      }
    })

    return (
      <ModalFullScreen
        padding={'50px 0 0'}
        allowEscape
        closeCallback={this.closeTheModalBound}
        isClosing={this.state.isClosing}
        backgroundColor="rgba(36, 54, 70, 0.4)"
        allowCloseOnExternalClick
        bodyStyles={{ width: 'fit-content' }}
      >
        <CloseModal size={21} onClick={this.closeTheModalBound} offWhiteIcon />
        <Container
          onClick={e => {
            e.stopPropagation()
          }}
        >
          {!levelDetails ? (
            <div style={{ minHeight: '300px' }}>
              <LoadingSpinner />
            </div>
          ) : (
            <React.Fragment>
              <ModalTop color={levelDetails.master_course.color}>
                {levelDetails.mastery ? (
                  <MasteryLevelImage
                    style={{
                      height: '116px'
                    }}
                    courseColor={levelDetails.master_course.color}
                  />
                ) : isActivityCourse ? (
                  <ActivityCourseCourseImage
                    style={{
                      height: '116px'
                    }}
                    courseColor={levelDetails.master_course.color}
                  />
                ) : (
                  levelDetails.master_course.master_course_avatar && (
                    <CourseImage
                      style={{
                        height: '116px'
                      }}
                      imageUrl={
                        levelDetails.master_course.master_course_avatar
                          .photo_url
                      }
                      courseColor={levelDetails.master_course.color}
                    />
                  )
                )}
                <FlexAlignCenter
                  style={{
                    position: 'relative',
                    width: '100%',
                    justifyContent: 'space-between'
                  }}
                >
                  <H1 white>
                    {level.mastery ? `Mastery ${lexicon.level}` : `${lexicon.level} ${level.number}`}
                  </H1>
                  {levelProgress?.mentor_target_on && (
                    <div
                      style={{
                        borderRadius: '7px',
                        backgroundColor: 'rgba(255,255,255,0.7)',
                        padding: '8px 20px',
                        display: 'flex'
                      }}
                    >
                      <TargetDateDueText
                        date={levelProgress.mentor_target_on}
                        styleComponent={Caption2}
                        cssClass="target-date"
                      />
                    </div>
                  )}
                </FlexAlignCenter>
              </ModalTop>

              <ModalBody>
                <P1Description className="markdown">
                  <MarkdownRenderer
                    markdown={levelDetails.description}
                    options={{
                      linkTarget: '_blank'
                    }}
                  />
                </P1Description>

                <div style={{ width: '489px' }}>
                  <MentorGuidanceContext.Provider
                    value={{
                      courseSectionId: courseSectionId,
                      levelId: level.id,
                      questId: null,
                      activityId: null,
                      paddingLR: 0,
                      rightOffsetDeleteButton: 80,
                      background: '#f8f8f8'
                    }}
                  >
                    <MentorGuidance type={MENTOR_GUIDANCE_TYPE.LEVEL} />
                  </MentorGuidanceContext.Provider>
                </div>

                {requiredQuests.length > 0 && (
                  <LevelQuests
                    quests={requiredQuests}
                    count={levelDetails.required_quests_count}
                    label={lexicon.core}
                    handleQuestClick={handleQuestClick}
                    courseColor={courseColor}
                    shouldDisplayTargetDateIcon={true}
                    targetDate={targetDate}
                    shouldShowDate={true}
                    courseSectionId={courseSectionId}
                    isUserEnrolled={isUserEnrolled}
                  />
                )}
                {choiceQuests.length > 0 && (
                  <LevelQuests
                    quests={choiceQuests}
                    count={
                      levelDetails.minimum_optional_quests_required_for_completion
                    }
                    label={lexicon.choice}
                    handleQuestClick={handleQuestClick}
                    courseColor={courseColor}
                    shouldDisplayTargetDateIcon={true}
                    targetDate={targetDate}
                    shouldShowDate={true}
                    courseSectionId={courseSectionId}
                    isUserEnrolled={isUserEnrolled}
                  />
                )}
              </ModalBody>
            </React.Fragment>
          )}
        </Container>
      </ModalFullScreen>
    )
  }

  closeTheModal() {
    const { dispatch } = this.props
    this.setState({
      isClosing: true
    })

    setTimeout(() => {
      dispatch(hideModal())
    }, 500)
  }
}

LevelModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  apiData: PropTypes.object.isRequired,
  courseId: PropTypes.number.isRequired,
  masterCourseId: PropTypes.number.isRequired,
  level: PropTypes.object.isRequired,
  levelProgress: PropTypes.array.isRequired,
  handleQuestClick: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  courseColor: PropTypes.string.isRequired,
  targetDate: PropTypes.array,
  shouldShowDate: PropTypes.bool
}

export const mapStateToProps = (state, ownProps) => {
  let courseSectionId, masterCourse
  if (ownProps.isUserEnrolled) {
    // find the course info from user enrollements
    const userCourses = [
      ...state.usercourses.currentUserCourses,
      ...state.usercourses.pastUserCourses,
    ]
    const course = userCourses.find(
      c => c.master_course.id === ownProps.masterCourseId
    )
    courseSectionId = course && course.course_section_id
    masterCourse = course && course.master_course
  } else {
    // find the course info from student enrollments
    // (when mentor is viewing student profile)
    const studentCourses = getJourneysGroupedByMasterCourse({
      state,
      excludeNonAcademicYearCourses: true
    })
    const course = studentCourses.find(
      c => c.masterCourse.id === ownProps.masterCourseId
    )
    courseSectionId = course && course.enrollments.length > 0
      && course.enrollments[0].course_section.id
    masterCourse = course && course.masterCourse
  }

  return {
    orgId: state.organization.orgId,
    token: state.auth.token,
    userId: state.auth.user.id,
    courseSectionId,
    isActivityCourse: masterCourse
      && masterCourse.operational_type === 'mentor_custom'
  }
}

export default connect(mapStateToProps)(withApiData(LevelModal))
export { LevelModal as LevelModalDisconnected }
